import DeleteIcon from '@mui/icons-material/Delete';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  ImageList,
  ImageListItem,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { HeaderCard } from '../../../event/components/HeaderCard';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { useCurrentUserQuery } from '../../hooks/useCurrentUserQuery';
import { useDeleteImageMutation } from '../../hooks/useDeleteImageMutation';
import { ImageUploader } from './components/ImageUploader';

export const UserImages: FunctionComponent = () => {
  const { data: currentUserData } = useCurrentUserQuery();
  const { deleteImage } = useDeleteImageMutation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const images = currentUserData?.currentUser?.images ?? [];

  return (
    <Layout title="Mes photos" activeTab="userImages">
      <HeaderCard
        title="Ajoutez vos photos"
        description="Nous utilisons vos images pour les jeux comme Meetic et Target. Vous pouvez ajouter jusqu'à 6 photos."
      />
      <Card>
        <CardContent>
          <ImageList
            variant="standard"
            cols={isMobile ? 1 : isTablet ? 2 : 3}
            gap={16}
            rowHeight={250}
          >
            {images.map((image) => (
              <ImageListItem
                key={image.id}
                sx={{ borderRadius: 2, overflow: 'hidden' }}
              >
                <img
                  srcSet={image.url}
                  src={image.url}
                  alt={image.originalName}
                  loading="lazy"
                />
                <Box
                  sx={{
                    position: 'absolute',
                    right: 4,
                    top: 4,
                    bgcolor: 'background.paper',
                    borderRadius: 100,
                  }}
                >
                  <IconButton
                    color="error"
                    onClick={() => deleteImage(image.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </ImageListItem>
            ))}
            {images.length < 6 ? (
              <ImageListItem>
                <ImageUploader maxImages={6 - images.length} />
              </ImageListItem>
            ) : null}
          </ImageList>
        </CardContent>
      </Card>
    </Layout>
  );
};
